import React, { useState, useEffect } from 'react';

import { toast } from 'react-toastify';

import { MdSave } from 'react-icons/md';
import { Form, Input } from '@rocketseat/unform';
import { useParams } from 'react-router-dom';

import Container from '~/components/Container';
import Title from '~/components/Title';
import Footer from '~/components/Footer';
import User from '~/components/User';
import Nav from '~/components/Navigation';

import api from '~/services/api';

import { Content, Bloco, Card, Editar } from './styles';

export default function EditGeral() {
  const { id } = useParams();
  const [tab, setTab] = useState('');

  useEffect(() => {
    async function loadTab() {
      const response = await api.get(`tb/geral/${id}`);

      setTab(response.data);
    }

    loadTab();
  }, [id]);

  async function handleUpdate({ title }) {
    try {
      await api.put(`tb/geral/${id}`, {
        title,
      });

      toast.success('Atualizado com sucesso');
    } catch (err) {
      toast.error('Erro na atualização');
    }
  }

  return (
    <>
      <Nav page="itens" />
      <Container>
        <User />

        <Content>
          <Title title="Itens / Tabelas / Certidões Negativas" />
          <Bloco>
            <div>
              <h2>Certidões Negativas</h2>
            </div>
          </Bloco>
        </Content>

        <Card>
          <Editar>
            <Form onSubmit={handleUpdate} initialData={tab}>
              <Input name="title" />
              <button type="submit">
                <MdSave size={18} color="#fff" /> Atualizar
              </button>
            </Form>
          </Editar>
        </Card>

        <Footer />
      </Container>
    </>
  );
}
